var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPseIconProjectNotext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 15.875 15.875",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.357 1.955 4.148 3.23a.37.37 0 0 0-.182.315v2.551c0 .13.07.25.182.315l2.208 1.275c.124.068.25.066.363 0l2.209-1.275a.364.364 0 0 0 .182-.314V3.546c0-.133-.067-.246-.201-.323L6.716 1.956c-.132-.068-.245-.067-.36-.001zm.182.734 1.48.856-1.48.855-1.48-.855zM4.695 4.175l1.48.854v1.71l-1.48-.855zm3.688 0v1.71l-1.481.854v-1.71zm2.212.028a.374.374 0 1 0 0 .748h3.212v4.042h-2.525l.425-.425a.373.373 0 1 0-.53-.53l-1.062 1.064a.378.378 0 0 0-.104.336.355.355 0 0 0 .055.134v.001c.014.02.03.04.05.059l1.063 1.064a.373.373 0 1 0 .529-.53l-.426-.425h2.898a.373.373 0 0 0 .374-.37v-.003l.001-4.79a.373.373 0 0 0-.37-.374h-.003z",
    fill: "#007dad",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    },
    transform: "translate(-1.323 1.292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.563 8.438c-.124 0-.249.03-.344.088L4.298 9.714c-.191.119-.191.309 0 .427l1.87 1.157a.715.715 0 0 0 .69 0l1.92-1.188c.191-.118.191-.308 0-.427l-1.87-1.157a.666.666 0 0 0-.345-.088z",
    fill: "#8ac9e1",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    },
    transform: "translate(-1.323 1.292)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPseIconProjectNotext);
export default __webpack_public_path__ + "static/media/pse-icon-project-notext.e68f7e5e1778971708dcd5b7afe1be86.svg";
export { ForwardRef as ReactComponent };